import React from "react";

// Default layout with navigation
const FoodstarterLayout = props => {
  // compatMode:
  // - Just pass through, still handled by application layout
  if (props.compatMode) {
    return <div>{props.children}</div>;
  }

  return (
    <div>
      {props.navigation && (
        <div id="header">
          <props.navigation />
        </div>
      )}

      <div className="container-fluid content-margin">{props.children}</div>
    </div>
  );
};

export default FoodstarterLayout;
